const triggerBlobDownload = (blobUrl, filename) => {
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const buildContractDownloadFilename = ({ requestId, dni, demoMode = false }) => {
  if (demoMode) {
    return `contrato-prestamo-${dni || 'demo'}.html`;
  }

  if (requestId) {
    return `contrato-solicitud-${requestId}.pdf`;
  }

  return 'contrato.pdf';
};

export const downloadContractFromUrl = async (url, filename) => {
  if (!url) {
    throw new Error('No hay un contrato disponible para descargar.');
  }

  if (!filename) {
    throw new Error('No se pudo determinar el nombre del archivo.');
  }

  if (url.startsWith('blob:')) {
    triggerBlobDownload(url, filename);
    return;
  }

  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('No se pudo descargar el contrato.');
  }

  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);

  try {
    triggerBlobDownload(objectUrl, filename);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};
